import CryptoJS from "crypto-js";

//const SECRET_KEY = process.env.REACT_APP_ENCRYPT_KEY; 

// function to encrypt data using encryption key from environment variable
export const encryptPassword = (password) => {
  const encryptedPassword = CryptoJS.MD5(password).toString();
  return encryptedPassword;
};

// function to encrypt data using decrypt key from environment variable
// export const decryptPassword = (encryptedPassword) => {
//   const bytes = CryptoJS.AES.decrypt(encryptedPassword);
//   const decryptedPassword = CryptoJS.enc.Utf8.stringify(bytes);
//   return decryptedPassword;
// };
